<flex-select-tree-input #flexSelectTreeInput 
  *ngIf="quals"
  [nodes]="qualNodes" [placeholder]="placeholder" [multiple]="multiple" [showCheckAll]="showCheckAll"
  [formControl]="myControl">
</flex-select-tree-input>
